import Vue from 'vue';
import Buefy from 'buefy';

Vue.use(Buefy, {
	defaultIconPack: 'fas',
	defaultUseHtml5Validation: false,
	defaultDatepickerYearsRange: [-100, 100]
});